import * as TagUtil from 'schemas/tags/TagUtil';
import {SampleGroupUpdate} from 'workflows/WorkflowConstants';

import {PreparedUISampleGroup} from './PreparedSampleGroupConstants';

export default function prepareSampleGroupsForServer(
  sampleGroups: Array<PreparedUISampleGroup>
): Array<SampleGroupUpdate> {
  const sampleGroupsWithSamples = sampleGroups.filter((sampleGroup) => {
    for (const tag of sampleGroup.tags) {
      if (tag.targetSamples != null && tag.targetSamples.length > 0) {
        return true;
      }
    }
    return false;
  });
  return sampleGroupsWithSamples.map((sampleGroup) => ({
    ...sampleGroup,
    // @ts-expect-error
    tags: TagUtil.getTagsToSet(sampleGroup.tags),
  }));
}
